<template>
    <rt-dialog append-to-body class="middle-dialog"  :show-footer="false" :title="$tx('审批进度', 'order.approvalPprogress')" width="640px" :close-on-click-modal="false" v-model="dialogVisible">
        <rt-approval-progress v-if="dialogVisible" :entity-name="entityName" :entity-id="entityId">
        </rt-approval-progress>
    </rt-dialog>
</template>


<script>
import RtApprovalProgress from './progress'

export default {
    name: 'RtApprovalProgressDialog',
    components: {
        'rt-approval-progress': RtApprovalProgress
    },
    data() {
        return {
            dialogVisible: false,
        }
    },
    props: {
        entityName: {
            type: String,
            require: true
        },
        entityId: {
            type: String,
            require: true
        }
    },
    methods: {
        show() {
            this.dialogVisible = true;
        }
    }

}
</script>



// WEBPACK FOOTER //
// progress-dialog.vue?690f02e8